import React, { useEffect, useState } from "react";
import { Button, Checkbox, Divider, Form, Input, Modal, Radio, Typography, Row, Col } from "antd"
import useNotify from "../utils/useNotify";
import SearchSelect from "../components/searchAndSelect";
import { addUser } from "../services/httpCalls";
import { showloader } from "../store/gloabalState";
import { useSetRecoilState } from "recoil";
import { Table } from "antd";
import { orgID } from "../store/gloabalState";
import { getOrgsDetails, updateUser } from "../services/httpCalls";
import "../assets/styles/createuser.scss"
import { Box, Paper } from "@mui/material";
import { PlusCircleFilled, PlusOutlined } from "@ant-design/icons";
import { cleanObject } from "../utils/onboarding/clean-object";

const UserTable = ({ orgId, companyType }) => {
    const [showuserList, setShowUserList] = useState([])
    const OrganizationID = useSetRecoilState(orgID);
    const setShowLoader = useSetRecoilState(showloader)
    const [isUserModalOpen, setIsUserModalOpen] = useState(false);
    const [edtinguserFlag, showEditUserFlag] = useState(false)
    const [editData, setEditUserData] = useState()
    const [userDataForm] = Form.useForm()
    const [refreshtable, setRefreshTable] = useState(false)
    const [orgName, setOrgName] = useState('')
    const [hideProductAuth, setHideProductAuth] = useState(true)


    const showUserModal = () => {
        setIsUserModalOpen(true);
        setEditUserData([])
        userDataForm.resetFields()
    };



    const handleUserModalCancel = () => {
        setIsUserModalOpen(false);
        userDataForm.resetFields()
    };
    const editDatauserFunc = (editData) => {
        showEditUserFlag(true)
        setIsUserModalOpen(true);
        setEditUserData(editData)
        userDataForm.resetFields()
        userDataForm.setFieldsValue({
            name: editData.name,
            email: editData.email,
            phone: editData.phoneNumber,
            isAuthorizer: editData?.isAuthorizer,
            rightsforInward: editData?.isActiveForInward,
            rightsforOutward: editData?.isActiveForOutward


        })
        setHideProductAuth(editData?.isAuthorizer ? false : true)
    }
    let notify = useNotify();
    const userCols = [
        {
            title: "Name",
            key: "name",
            dataIndex: "name",
            align: 'center'
        },
        {
            title: "Email",
            key: "email",
            dataIndex: "email",
            align: 'center'
        },
        {
            title: "Phone",
            key: "phoneNumber",
            dataIndex: "phoneNumber",
            align: 'center'
        },
        {
            title: "Products",
            key: "product",
            dataIndex: "product",
            align: 'center',
            render: (value, record) => {
                if (record?.isActiveForInward && record?.isActiveForOutward) {
                    return "Outward & Inward"
                }
                else if (record?.isActiveForInward && record?.isActiveForOutward !== true) {
                    return "Inward"
                }
                else if (record?.isActiveForInward !== true && record?.isActiveForOutward) {
                    return "Outward"
                }
                else {
                    return "-"
                }

            }
        },
        {
            title: "Authorized for",
            key: "auth",
            dataIndex: "auth",
            align: 'center',
            render: (value, record) =>
                <><p>Outward:{(record?.isActiveForInward && record?.isActiveForOutward) ? <b> YES</b> : <>
                    {(record?.isActiveForInward && record?.isActiveForOutward !== true) ? <b> NO</b> : record?.isActiveForOutward ? <b> YES</b> : "-"}

                </>}</p><p>Inward:{(record?.isActiveForInward && record?.isActiveForOutward) ? <b> YES</b> : <>
                    {(record?.isActiveForInward !== true && record?.isActiveForOutward) ? <b> NO</b> : record?.isActiveForInward ? <b> YES</b> : "-"}

                </>}
                    </p></>

        },
        {
            title: "Edit",
            align: "center",
            render: (value, record) => <Button type="primary" onClick={() => {
                editDatauserFunc(record)

            }}>Edit</Button>
        }

    ]
    const getOrgusers = (orgId) => {
        if (orgId) {
            setShowLoader(true);
            getOrgsDetails(orgId).then((res) => {
                setShowUserList(res?.userList);
                setOrgName(res?.name)
            }).catch(() => {

            }).finally(() => setShowLoader(false))
        } else {
            notify.error("Select Organisation from the list!");
        }
    }
    useEffect(() => {
        getOrgusers(orgId)
    }, [orgId, refreshtable])
    const handleFormSubmit = (values) => {
        let data = {
            name: values.name,
            email: values.email,
            phoneNumber: values.phone,
            isAuthorizer: values.isAuthorizer,
            isActiveForInward: values.rightsforInward ? true : false,
            isActiveForOutward: values.rightsforOutward ? true : false,
        }
        if (companyType === "SOLE_PRORIETOR") {
            delete data.isActiveForOutward
        }
        if (edtinguserFlag) {
            setShowLoader(true);
            let cleanData = cleanObject(data);
            updateUser(cleanData, orgId, editData.id)
                .then(() => {
                    notify.success("User details updated");
                    setRefreshTable(!refreshtable)
                    handleUserModalCancel()
                })
                .catch(() => {
                    notify.error("Not able to update details");
                    setShowLoader(false);
                }).finally(() => {
                    setShowLoader(false);
                });

        }
        else {

            if (values.name && values.email) {
                setShowLoader(true);
                let cleanData = cleanObject(data)
                addUser(orgId, cleanData)
                    .then((res) => {
                        notify.success("User Added successfully!");
                        setRefreshTable(!refreshtable)
                        handleUserModalCancel()

                    })
                    .catch((error) => {
                        notify.error("Not able to add user!");


                    }).finally(() => {
                        setShowLoader(false);
                    })
            }
        }

    }
    return <>
        <div className="usertable_heading">
            <Typography.Title level={3} style={{
                textTransform: "uppercase"
            }}>{`${orgName} - `}Users List</Typography.Title>
            <div className="userbutton" style={{
                margin: "1rem 0.5rem"
            }}>
                <Button type="primary" style={{
                }} onClick={() => {
                    showEditUserFlag(false)
                    showUserModal()
                    setHideProductAuth(true)
                }}>Add User</Button>
            </div>
        </div>
        <Box component={Paper}>
            <div className="user_table">
                <Table columns={userCols} dataSource={showuserList} className="styledAntd" pagination={{
                    pageSize: 7,
                    showSizeChanger: false,
                    position: ["bottomCenter"],
                }}
                    rowKey={(record) => record?.id}
                />
            </div>
        </Box>
        <Modal title={<Typography.Title level={4} style={{
            textTransform: "uppercase"
        }}>{edtinguserFlag ? `Edit user - ${editData?.name}
       ` : `Create user`}</Typography.Title>} open={isUserModalOpen} footer={null} onCancel={handleUserModalCancel}>
            <div className="user_edit_form" style={{
                width: "340px",

            }}>

                <Form layout="vertical" form={userDataForm} onValuesChange={(val) => {
                    if (val.isAuthorizer === true) {
                        setHideProductAuth(false)
                    }
                    if (val.isAuthorizer === false) {
                        setHideProductAuth(true)
                    }
                }}>
                    <Form.Item name={"name"} label="User Name" required rules={[{
                        required: true,
                        message: "Please enter Name"
                    },
                    {
                        validator: (_, value) => {
                            if(value && value.length>100){
                            return Promise.reject("Maximum character limit exceeded")
                            }

                            Promise.resolve();
                        }
                    }
                    ]}>
                        <Input />
                    </Form.Item>
                    <Form.Item name={"email"} label="Email" required rules={[{
                        required: true,
                        message: "Please enter Email"
                    },
                    {
                        pattern: new RegExp(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/),
                        message: "Please enter valid email!"
                    }
                    ]}>
                        <Input type="email" />
                    </Form.Item>
                    <Form.Item name={"phone"} label="Phone Number" required rules={[
                        {
                            min:10,
                            max: 10,
                            message: "Max length of phone number is 10"
                        }
                    ]}>
                        <Input type="number" maxLength={10} />
                    </Form.Item>
                    <Form.Item label="Is Authorizer ?" name={'isAuthorizer'}>
                        <Radio.Group>
                            <Radio value={true}>Yes</Radio>
                            <Radio value={false}>No</Radio>
                        </Radio.Group>
                    </Form.Item>
                    {hideProductAuth ? <>

                    </> : <>
                        <Typography.Text style={{
                            marginBottom: "30px"
                        }}>Rights for?</Typography.Text>
                        <Row gutter={[10, 10]}>
                            {
                                companyType !== "SOLE_PRORIETOR" ? <Col span={12}>
                                    <Form.Item name={"rightsforOutward"} valuePropName="checked">
                                        <Checkbox>OUTWARD</Checkbox>
                                    </Form.Item>
                                </Col> : <></>
                            }

                            <Col span={12}>
                                <Form.Item name={"rightsforInward"} valuePropName="checked">
                                    <Checkbox >INWARD</Checkbox>
                                </Form.Item>
                            </Col>
                        </Row>
                    </>}
                    <Button type="primary" htmlType="submit" onClick={() => handleFormSubmit(userDataForm.getFieldsValue())}>Submit</Button>
                </Form>

            </div>
        </Modal>

    </>
}

export default function CreateUser() {
    const [orgId, setOrgId] = useState();
    const [loadingButton, setLoadingButton] = useState(false);
    const [showuserList, setShowUserList] = useState([])
    const [showTable, setShowtable] = useState(false)
    const [companyType, setCompanyType] = useState("")
    const [createUserForm, setCreateUserForm] = useState({
        name: "",
        email: "",
        phoneNumber: "",
        isAuthorizer: false
    })
    const setShowLoader = useSetRecoilState(showloader)
    let notify = useNotify();
    const OrganizationID = useSetRecoilState(orgID);

    const createUser = async (e) => {
        e.preventDefault();
        setLoadingButton(true)
        let cleanCreateUserForm = cleanObject(createUserForm);
        if (createUserForm.name && createUserForm.email) {
            setShowLoader(true);
            addUser(orgId, createUserForm)
                .then((res) => {
                    notify.success("Added user successfully!");
                    setShowLoader(false);

                })
                .catch((error) => {
                    notify.error("Not able to add user!");
                    setShowLoader(false);

                })
        }
    }

    const selectSearchData = (e) => {
        setCompanyType(e.companyType)
        setOrgId(e.id)
        OrganizationID(e.id);
        setShowtable(false)

    }

    const getShowtable = () => {
        setShowtable(true)
    }

    return (
        <div className="org_user_container">

            <div className="organisation_search" style={{
                margin: "20px 0",
                display: "flex",
                alignItems: 'baseline',
                gap: "20px"
            }}>
                <SearchSelect selectSearchData={selectSearchData} label={"Search Organisation"} name={"orgSelect"} />
                <Button type="primary" onClick={getShowtable}>Search</Button>
            </div>

            {orgId && showTable && <UserTable orgId={orgId} companyType={companyType} />}


        </div>
    )
}